import AddressWithTime from "components/shared/addressWithTime";
import ForwardingSource from "components/shared/forwardingSource";
import SyncStatusInfo from "components/shared/syncStatusInfo";
import { counterpartyInsolvencyTooltip, getStatusByFields } from "helpers/bid";
import { sourceTypesEnum, syncEntityTypesEnum } from "helpers/enums";
import { HiddenDataWrapper, hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { formatNumber } from "helpers/system";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Bid extends Component {
    renderStatus = () => {
        const { item, mergeParams, modal } = this.props;
        return getStatusByFields(item, { modal, onInProcessReset: () => mergeParams({}) });
    };

    showBid = () => {
        const { id } = this.props.item;
        return this.props.history.push(paths.distributionBidShow(id));
    };

    render() {
        const {
            item,
            index,
            params,
            organization,
            showFullAddress,
            showAllPointAddresses,
            showOrganizationColumn,
            className,
        } = this.props;
        const {
            cargos,
            id,
            price,
            priceWithoutCosts,
            distance,
            output,
            outputWithoutCosts,
            counterparty,
            firstBidPoint,
            lastBidPoint,
            externalId,
            lastSyncStatus,
            sourceType,
            source,
            pointAddresses,
            legalPersonName,
            isMandatory,
            trailerTypeName,
            isPreBid,
            hasHiredCar,
            isShippingOrder,
        } = item;
        const displayedPrice = this.props.showCostAwareValues ? (priceWithoutCosts ?? price) : price;
        const displayedOutput = this.props.showCostAwareValues ? (outputWithoutCosts ?? output) : output;

        return (
            <tr onClick={this.showBid} className={className}>
                <td>{params.start + index + 1}</td>
                <td>
                    <small>
                        <Link className="mr-1" to={paths.distributionBidShow(id)}>
                            {id}
                        </Link>
                        {sourceTypesEnum.Forwarding === sourceType && (
                            <Tooltip placement="right" overlayClassName="notifys__tooltip" overlay="Внешний заказ">
                                <i className="icon-uEAB0-forward b-table__compound-icon mr-1" />
                            </Tooltip>
                        )}
                        {hasHiredCar && (
                            <Tooltip placement="right" overlayClassName="notifys__tooltip" overlay="Наемный ТС">
                                <i className="icon-uEAD4-hired-car b-table__compound-icon mr-1" />
                            </Tooltip>
                        )}
                    </small>
                    <SyncStatusInfo
                        id={id}
                        externalId={externalId}
                        lastSyncStatus={lastSyncStatus}
                        entityType={syncEntityTypesEnum.DistributionBid}
                    />
                    {isMandatory && <span className="badge badge-primary badge-pill mr-1">Обязательный</span>}
                    {isShippingOrder && <span className="badge badge-info badge-pill mr-1">ЭЗЗ</span>}
                </td>
                <td className="b-table__point-cell">
                    {firstBidPoint && <AddressWithTime point={firstBidPoint} showFullAddress={showFullAddress} />}
                </td>
                {showAllPointAddresses && (
                    <td className="b-table__cargo-cell">
                        {pointAddresses?.length > 2 ? (
                            <ul className="pl-2">
                                {pointAddresses.slice(1, -1).map((item, i) => (
                                    <li key={i} className="small">
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <>&mdash;</>
                        )}
                    </td>
                )}
                <td className="b-table__point-cell">
                    {lastBidPoint && <AddressWithTime point={lastBidPoint} showFullAddress={showFullAddress} />}
                </td>
                <td className="b-table__cargo-cell">
                    <small>{cargos[0]?.name}</small>
                    {cargos[0]?.weight && (
                        <>
                            <br />
                            <small>Вес: {cargos[0].weight}т</small>
                        </>
                    )}
                    {!!trailerTypeName && (
                        <>
                            <br />
                            <small>{trailerTypeName}</small>
                        </>
                    )}
                </td>
                <td className="b-table__price-cell">
                    {displayedPrice != null && (
                        <small>
                            {hiddenUserData(
                                formatNumber(displayedPrice, { style: "currency", currency: organization?.currency }),
                                { type: "price" },
                            )}
                        </small>
                    )}
                    {distance && (
                        <>
                            <br />
                            <small>{formatNumber(distance)}&nbsp;км</small>
                        </>
                    )}
                    {counterparty && (
                        <>
                            {displayedPrice != null && <br />}
                            <small>{hiddenUserData(counterparty.name, { type: "title" })}</small>
                            {counterparty?.insolvencyRegistryEntry &&
                                counterparty?.insolvencyRegistryEntry.insolvencyRank > 0 && (
                                    <HiddenDataWrapper>
                                        <br />
                                        {counterpartyInsolvencyTooltip(
                                            counterparty.insolvencyRegistryEntry,
                                            this.props.modal,
                                        )}
                                    </HiddenDataWrapper>
                                )}
                        </>
                    )}
                </td>
                <td className="b-table__price-cell">
                    <small>{hiddenUserData(formatNumber(displayedOutput), { type: "pricePerVal" })}</small>
                </td>
                <td className="b-table__source-cell">{source && <ForwardingSource {...source} />}</td>
                {showOrganizationColumn && (
                    <td className="b-table__cargo-cell">
                        <small>{legalPersonName}</small>
                    </td>
                )}
                <td>
                    {this.renderStatus()}
                    {isPreBid && (
                        <>
                            <br />
                            <span className="badge badge-secondary">Предзаявка</span>
                        </>
                    )}
                </td>
            </tr>
        );
    }
}
